export const RESTAURANT_SETTINGS_ID = "00000000-0000-0000-0000-000000000001";
